<div class="container">
    <div class="header-container">
        <span class="h3-regular header-title">{{ data.id }}</span>
    </div>
    <div class="body-container">
        <div>
            <span class="span-autotag body-3">{{data.label}}</span>
        </div>
        <div class="switch-autotag inner-block-top">
            <kendo-switch [checked]="data.hide" onLabel="Yes" offLabel="No" (valueChange)="changeEnable($event)">
            </kendo-switch>
        </div>
    </div>
</div>